import Result from "../model/result";

export const EOSService = {
    async makeRequest(request, callback) {
        return await request.then((response) => {
            if (callback) {
                callback(response);
            }
            var data = response.data
            if (data.ResponseResultType === 1) {
                return Result.success(data.Values, data.Message, data)
            } else {
                ////console.log(response);
                return Result.error(data.Message, data.Message, data)
            }
        }).catch((err) => {
            if (callback) {
                callback(err);
            }
            //EosUtils.Log('EOSService: test')
            if (err?.response?.statusText) {
                return Result.error(err.response.statusText)
            } else {
                return Result.error()
            }
        })
    },
};